import { AppSocketType, SocketMessageTypes, WorkerEvent } from 'Modules/Socket'
import {
	actionChat,
	chatSelectors,
	ChatSocketChannel,
	ChatSocketNS,
	serializeParams,
	WsCommands,
} from 'Pages/chat'
import { select } from 'typed-redux-saga'

export function* sendMessage(data: ChatSocketNS.SendMessage) {
	const currentChat = yield* select(chatSelectors.currentChat)
	const chat_id = currentChat?.id

	navigator.serviceWorker.controller.postMessage({
		appSocketType: AppSocketType.UNI_CHAT,
		data: {
			type: WorkerEvent.SEND_MESSAGE,
			payload: JSON.stringify({
				command: WsCommands.MESSAGE,
				identifier: `{"channel": "${ChatSocketChannel.CHAT_CHANNEL}", "chat_id": ${chat_id}}`,
				data: serializeParams(data.payload),
			}),
		},
	})
}

export function* sendPingMessage() {
	const currentChat = yield* select(chatSelectors.currentChat)
	const chat_id = currentChat?.id

	navigator.serviceWorker.controller.postMessage({
		appSocketType: AppSocketType.UNI_CHAT,
		data: {
			type: WorkerEvent.SEND_MESSAGE,
			payload: JSON.stringify({
				command: WsCommands.MESSAGE,
				identifier: `{"channel": "${ChatSocketChannel.PING_CHANNEL}", "chat_id": ${chat_id}}`,
				data: `{"action": "${actionChat.SPEAK}", "text": "${SocketMessageTypes.PING}"}`,
			}),
		},
	})
}
